import easyToggle from "easy-toggle-state";
// import initialize from "easy-toggle-state";
import Plyr from "plyr";

import InlineVideo from "./blocks/InlineVideo";
import SplitTextTitle from "./blocks/SplitTextTitle";
import PromoReel from "./blocks/PromoReel";
import PageIntro from "./blocks/PageIntro";
import StepsBox from "./blocks/StepsBox";
import TickerLogos from "./blocks/TickerLogos";
import Reviews from "./blocks/Reviews";
import PromoInfo from "./blocks/PromoInfo";
import Ticker from "./blocks/Ticker";
import VoiceCloning from "./blocks/VoiceCloning";
import Intro from "./blocks/Intro";
import CasesBox from "./blocks/CasesBox";
import Header from "./blocks/Header";
import PostsList from "./blocks/PostsList";
import StickyMobileBar from "./blocks/StickyMobileBar";
import LogosTiles from "./blocks/LogosTiles";
import NavMenu from "./blocks/NavMenu";
import ArticleWrap from "./blocks/ArticleWrap";
import MagicBox from "./blocks/MagicBox";
import TimelineBox from "./blocks/TimelineBox";
import HeaderSimple from "./blocks/HeaderSimple";
// import ContactBox from "./blocks/ContactBox";
import AudioWidget from "./blocks/AudioWidget";
import AnimBg from "./blocks/AnimBg";
import StickyAudioPlayer from "./blocks/StickyAudioPlayer";
import Footer from "./blocks/Footer";
import ActorsTiles from "./blocks/ActorsTiles";
import TabsVideoBox from "./blocks/TabsVideoBox";
import VoiceTile from "./blocks/VoiceTile";
import PromoInfoBox from "./blocks/PromoInfoBox";
import Usecases from "./blocks/Usecases";
import ClientsBox from "./blocks/ClientsBox";
import ToggleSwitch from "./blocks/ToggleSwitch";
import SubscriptionPlans from "./blocks/SubscriptionPlans";
import TariffsBox from "./blocks/TariffsBox";
import ChangeVoiceVideo from "./blocks/ChangeVoiceVideo";
import PlanChooser from "./blocks/PlanChooser";
import BookBox from "./blocks/BookBox";
import VoicesPromo from "./blocks/VoicesPromo";
import ReviveVoices from "./blocks/ReviveVoices";
import SubtitlesBox from "./blocks/SubtitlesBox";
import ProjectsIntro from "./blocks/ProjectsIntro";
import ApplicationsBox from "./blocks/ApplicationsBox";
import SiteDescription from "./blocks/SiteDescription";
import VoiceCard from "./blocks/VoiceCard";
import JobCard from "./blocks/JobCard";
// import ReviewsSlider from "./blocks/ReviewsSlider";

const initScripts = () => {
	easyToggle();

	document.querySelectorAll(".modal").forEach((modal) => {
		document.querySelector(`#${modal.getAttribute("id")}`).addEventListener("toggleBefore", event => {
			// document.dispatchEvent(new Event("modal-open"));
			const inlineVideo = event.target.querySelectorAll(".inline-video");
			if (inlineVideo) {
				inlineVideo.forEach((widget) => {
					const video = widget.querySelector(".inline-video__el");
					const source = widget.querySelector("source");
					const dataSrc = source.getAttribute("data-src");
					if (dataSrc) {
						source.setAttribute("src", dataSrc);
						video.setAttribute("preload", "auto");
						video.load();
					}
				});
			}

			const audioWidget = event.target.querySelectorAll(".audio-widget");
			if (audioWidget) {
				audioWidget.forEach((widget) => {
					const track = widget.querySelector(".audio-widget__track");
					const source = track.querySelector("source");
					const dataSrc = source.getAttribute("data-src");
					if (dataSrc) {
						source.setAttribute("src", dataSrc);
						track.load();
					}
				});
			}
		}, false);
		document.querySelector(`#${modal.getAttribute("id")}`).addEventListener("toggleAfter", event => {
			document.dispatchEvent(new Event("modal-closed"));
		}, false);
	});

	// form field blur state
	document.querySelectorAll(".form-control").forEach((input) => {
		input.addEventListener("focus", (e) => {
			e.target.closest(".form-group").classList.add("has-value");
		});

		input.addEventListener("blur", (e) => {
			if (!e.target.value) {
				e.target.closest(".form-group").classList.remove("has-value");
			}
		});
	});

	// hubspot field blur state
	const hbsptFieldsStickyLabel = () => {
		document.querySelectorAll(".hs-form-field").forEach((field) => {
			const input = field.querySelector(".hs-input");

			input.addEventListener("focus", (e) => {
				field.classList.add("has-value");
			});

			input.addEventListener("blur", (e) => {
				if (!e.target.value) {
					if (!e.target.classList.contains("is-placeholder")) {
						field.classList.remove("has-value");
					}
				}
			});

			if (input.value) {
				field.classList.add("has-value");
			}

			if (input.classList.contains("is-placeholder")) {
				field.classList.add("has-value");
			}
		});
	};

	// update choices selected value width
	const updateChoicesWidth = () => {
		const choicesElements = document.querySelectorAll(".choices");
		choicesElements.forEach(choicesEl => {
			const choicesWidth = choicesEl.closest("form").offsetWidth - 40;
			const selectableItems = choicesEl.querySelectorAll(".choices__list--single .choices__item--selectable");
			selectableItems.forEach(item => {
				item.style.maxWidth = `${choicesWidth}px`;
			});

			choicesEl.addEventListener("change", (e) => {
				updateChoicesWidth();
			});
		});
	};
	window.addEventListener("resize", updateChoicesWidth);

	// hubspot choices select
	const initHsSelect = () => {
		const hsSelect = document.querySelectorAll("select.hs-input");
		if (hsSelect) {
			const labels = window.firstStepOptionsLabels;
			const allowedValuesPersonal = window.allowedValuesPersonal;
			const allowedValuesBusiness = window.allowedValuesBusiness;
			const allowedValuesOther = window.allowedValuesOther;

			hsSelect.forEach((el) => {
				if (el.closest("#form_basic") && labels && allowedValuesPersonal && allowedValuesBusiness && allowedValuesOther) {
					const choices = new Choices(el, {
						allowHTML: true,
						searchEnabled: false,
						itemSelectText: "",
						shouldSort: false,
						callbackOnCreateTemplates: function(template) {
							return {
								choice: (classNames, data) => {
									const safeClassNames = {
										item: classNames?.item || 'choices__item',
										itemChoice: classNames?.itemChoice || 'choices__item--choice',
										itemDisabled: classNames?.itemDisabled || 'choices__item--disabled',
										itemSelectable: classNames?.itemSelectable || 'choices__item--selectable',
										highlightedState: classNames?.highlightedState || 'is-highlighted'
									};
									const label = labels.find(label => label.id === data.value)?.label;
									
									return template(`
										<div class="${safeClassNames.item} ${safeClassNames.itemChoice} ${data.disabled ? safeClassNames.itemDisabled : safeClassNames.itemSelectable}" data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'} data-id="${data.id}" data-value="${data.value}" ${data.placeholder ? 'data-placeholder' : ''} ${data.highlighted ? safeClassNames.highlightedState : ''}>
											<div class="choices__item-label">${data.label}</div>
											${label ? `<div class="choices__item-custom-label">${label}</div>` : ''}
										</div>
									`);
								}
							};
						}
					});

					const radioList = document.querySelectorAll("#form_basic .inputs-list input[type='radio']");
					if (radioList) {
						const checkedRadio = document.querySelector("#form_basic .inputs-list input[type='radio']:checked");
						const clearInactiveOptions = () => {
							choices._store.choices.forEach(choice => {
								const item = choices.choiceList.element.querySelector(`[data-id="${choice.id}"]`);
								item.classList.remove('choices__item--inactive');
							});
							choices.setChoiceByValue('');
						};
						const setInactiveOptions = (allowedValues) => {
							choices._store.choices.forEach(choice => {
								const item = choices.choiceList.element.querySelector(`[data-id="${choice.id}"]`);
								if (!item) return;
						
								if (item.hasAttribute('data-placeholder')) return;

								if (!allowedValues.includes(choice.value)) {
									item.classList.add('choices__item--inactive');
								}
							});
						};
						const validateOptions = (selectedValue) => {
							if (selectedValue === 'Other') {
								clearInactiveOptions();
								setInactiveOptions(allowedValuesOther);
							} else  if (selectedValue === 'Individual / Personal Use') {
								clearInactiveOptions();
								setInactiveOptions(allowedValuesPersonal);
							} else if (selectedValue === 'Business / Organization') {
								clearInactiveOptions();
								setInactiveOptions(allowedValuesBusiness);
							} else {
								clearInactiveOptions();
							}
						};
						if (checkedRadio && checkedRadio.value) {
							validateOptions(checkedRadio.value);
						}
						
						radioList.forEach((radio) => {							
							radio.addEventListener("change", (e) => {
								validateOptions(e.target.value);
							});
						});
					}
				} else {
					const choices = new Choices(el, {
						allowHTML: true,
						searchEnabled: false,
						itemSelectText: "",
						shouldSort: false
					});
				}
			});
			updateChoicesWidth();
		}
	};

	// hs-form-inline
	const hsInlineForm = () => {
		const formInline = document.querySelectorAll(".hs-email-form-inline");

		formInline.forEach((el) => {
			if (!el.querySelector(".hs-form-row")) {
				const form = el.querySelector("form");
				const field = el.querySelector(".hs-email");
				const submit = el.querySelector(".hs-submit");

				const row = document.createElement("div");
				row.classList.add("hs-form-row");
				form.prepend(row);

				row.append(field);
				row.append(submit);
			}
		});
	}

	const getGA4ClientId = () => {
		const cookies = document.cookie.split('; ');
		const gaCookie = cookies.find(cookie => cookie.startsWith('_ga'));
		if (gaCookie) {
			return gaCookie.split('.').slice(-2).join('.');
		}
		return null;
	}

	const hsGAFields = () => {
		const gaFields = document.querySelectorAll('input[name="ga_id"]');
		if (gaFields) {
			gaFields.forEach((field) => {
				field.value = getGA4ClientId();
			});
		}
	}

	document.addEventListener("hbspt-form-ready", (e) => {
		hbsptFieldsStickyLabel();
		initHsSelect();
		hsInlineForm();
		hsGAFields();
	});

	// const beforeUnloadHandler = (event) => {
	// 	event.preventDefault();
	// 	document.dispatchEvent(new Event ("get-exit-popup"));
	// }
	// window.addEventListener("beforeunload", beforeUnloadHandler);

	// get exit popup
	// document.addEventListener("get-exit-popup", (e) => {
	// 	const modal = document.querySelector("#modal-exit");
	// 	const closeControls = modal.querySelectorAll("[data-toggle-trigger-off]");

	// 	modal.classList.add("is-opened");
	// 	modal.setAttribute("aria-hidden", "false");

	// 	closeControls.forEach((control) => {
	// 		control.addEventListener("click", (e) => {
	// 			modal.classList.remove("is-opened");
	// 			modal.setAttribute("aria-hidden", "true");
	// 		});
	// 	});
	// });

	// responsive table
	const tableWrapper = () => {
		document.querySelectorAll(".rich-text table").forEach((table) => {
			if (!table.closest("td")) {
				const wrap = document.createElement("div");
				wrap.classList.add("table-responsive");
				table.parentNode.insertBefore(wrap, table);
				wrap.appendChild(table);
			}
		});
	};
	tableWrapper();

	// embed responsive iframe
	const embedResponsive = () => {
		document.querySelectorAll(".rich-text iframe").forEach((frame) => {
			if (!frame.closest(".embed-responsive")) {
				const wrap = document.createElement("div");
				wrap.classList.add("embed-responsive");
				frame.parentNode.insertBefore(wrap, frame);
				wrap.appendChild(frame);
			}
		});
	};
	embedResponsive();

	// select
	const selectChoice = document.querySelectorAll(".select-choice");
	if (selectChoice) {
		selectChoice.forEach((select) => {
			const choices = new Choices(select, {
				allowHTML: true,
				searchEnabled: false,
				itemSelectText: "",
				shouldSort: false
			});
		});
	}

	// rich text audio
	const richAudio = document.querySelectorAll(".rich-text audio");
	if (richAudio.length) {
		richAudio.forEach(audio => {
			if (!audio.closest(".audio-widget")) {
				const wrap = document.createElement("div");
				wrap.classList.add("audio-widget");
				audio.parentNode.insertBefore(wrap, audio);
				wrap.appendChild(audio);
			}
		});
	}
};

initScripts();
InlineVideo();
SplitTextTitle();
PromoReel();
PageIntro();
StepsBox();
TickerLogos();
Reviews();
PromoInfo();
Ticker();
VoiceCloning();
Intro();
CasesBox();
Header();
PostsList();
StickyMobileBar();
LogosTiles();
NavMenu();
ArticleWrap();
MagicBox();
TimelineBox();
HeaderSimple();
// ContactBox();
AudioWidget();
AnimBg();
StickyAudioPlayer();
Footer();
ActorsTiles();
TabsVideoBox();
VoiceTile();
PromoInfoBox();
Usecases();
ClientsBox();
ToggleSwitch();
SubscriptionPlans();
TariffsBox();
ChangeVoiceVideo();
PlanChooser();
BookBox();
VoicesPromo();
ReviveVoices();
SubtitlesBox();
ProjectsIntro();
ApplicationsBox();
SiteDescription();
VoiceCard();
JobCard();
// ReviewsSlider();
